





























import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Picker extends Vue {
  @Prop({ type: Object, required: false }) private btnObj!: any;
  @Prop({ type: String, required: false }) private pickerContent!: string;
  @Prop({ type: Boolean, required: false }) private isShow!: boolean;

  private screenHight: any;
  private marginTopTips: string = '';
  private textContent: string = '';
  private searchPicker: string = '搜索';
  private mounted() {
    this.screenHight = document.documentElement.clientHeight;
  }
  private created() {
    //   console.log(this.btnObj.type);
  }

  private sendText(item: any) {
    if (item.text === "自定义") {
      //  弹出输入框？
    } else {
      this.$emit('confirm', item.text);
    }
  }

  private opens() {
    this.$emit('cancel');
  }

  @Watch('isShow')
  private onChangeValue(val: number, old: any) {
    const refelement = ( this.$refs.element as any );
    refelement.style.transform = 'translate3d(0%, ' + this.screenHight + 'px, 0)';
    if (this.btnObj.type === 3) {
        this.marginTopTips = this.screenHight * 0.37 + 'px';
    } else {
        this.marginTopTips = this.screenHight * 0.43 + 'px';
    }
    refelement.style.transform = 'translate3d(0%, ' + 0 + ', 0)';
  }
}
